import React, { useCallback, useState } from "react";

export interface UseAnchorElement {
  anchorEl: HTMLElement | null;
  anchorElement: HTMLElement | null;
  open: boolean;
  width: string;
  onClose: () => void;
  onClick: React.MouseEventHandler<HTMLElement>;
  setAnchorElement: (element: HTMLElement | null) => void;
}

/**
 * For use when a component requires an anchor element (e.g. Menus); width can be used
 * for matching the width of the anchored component to the width of the anchor
 */
const useAnchorElement = (): UseAnchorElement => {
  const [width, setWidth] = useState<UseAnchorElement["width"]>("auto");
  const [anchorElement, setAnchorElement] =
    useState<UseAnchorElement["anchorElement"]>(null);
  const open = Boolean(anchorElement);

  const handleClose: UseAnchorElement["onClose"] = useCallback(
    () => setAnchorElement(null),
    []
  );

  const handleClick: UseAnchorElement["onClick"] = useCallback(
    (event) => {
      const targetWidth = `${event.currentTarget.clientWidth}px`;
      if (width !== targetWidth) {
        setWidth(targetWidth);
      }
      setAnchorElement(event.currentTarget);
    },
    [width]
  );

  return {
    anchorEl: anchorElement,
    anchorElement,
    open,
    width,
    onClose: handleClose,
    onClick: handleClick,
    setAnchorElement,
  };
};

export default useAnchorElement;
